import { make } from 'vuex-pathify'
import Vue from 'vue'
import store from '../index'

const state = {
  loading: [false, false],
}

const mutations = make.mutations(state)

const createJob = async ({ state }, { reportCode, filter = {} }) => {
  const type = filter.type || 0
  Vue.set(state.loading, type, true)

  try {
    return await store.dispatch('reportJobStore/createJob', {
      module: 'request',
      reportCode,
      format: type === 0 ? 'pdf' : 'csv',
      filters: filter,
    })
  } finally {
    Vue.set(state.loading, type, false)
  }
}

const actions = {
  getRequests: (ctx, filter = {}) => createJob(ctx, { reportCode: 'requests', filter }),
  getPayments: (ctx, filter = {}) => createJob(ctx, { reportCode: 'payments', filter }),
  getCommissions: (ctx, filter = {}) => createJob(ctx, { reportCode: 'commissions', filter }),
  getGoals: (ctx, filter = {}) => createJob(ctx, { reportCode: 'goals', filter }),
}

const getters = make.getters(state)

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
